import { connect } from 'react-redux';
import ModalManager from './ModalManager';
import { RootState } from 'store/types';

const mapStateToProps = (state: RootState) => ({
  modal: state.modal,
});

export default connect(mapStateToProps)(ModalManager);
